<template>
	<div class="wf-poi" v-if="poi">
		<div class="wf-poi-info">
			<div class="wf-poi-image" v-if="showLogo" :style="{'background-image': getImage}" :class="[isImage()]"></div>
			<div class="wf-poi-name" v-if="showName" v-html="poi.getName(language) || 'POI'"></div>
			<div class="wf-show-path" v-if="showPathButton" v-touch:tap="showPath">
				<button class="show-path-button">
					<label data-translation-element="show_path">{{show_path}}</label>
					<svg class="path-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
						<path d="M13.5,5.5C14.59,5.5 15.5,4.58 15.5,3.5C15.5,2.38 14.59,1.5 13.5,1.5C12.39,1.5 11.5,2.38 11.5,3.5C11.5,4.58 12.39,5.5 13.5,5.5M9.89,19.38L10.89,15L13,17V23H15V15.5L12.89,13.5L13.5,10.5C14.79,12 16.79,13 19,13V11C17.09,11 15.5,10 14.69,8.58L13.69,7C13.29,6.38 12.69,6 12,6C11.69,6 11.5,6.08 11.19,6.08L6,8.28V13H8V9.58L9.79,8.88L8.19,17L3.29,16L2.89,18L9.89,19.38Z"/>
					</svg>
				</button>
			</div>
		</div>
		<div class="wf-poi-description-wrapper">
			<div 
				class="wf-poi-description" 
				v-if="showDescription && getDescription()" 
				v-html="getDescription()"
				@touchstart.stop
				@touchmove.stop
				@touchend.stop
			></div>
		</div>
		<div class="wf-poi-room_id" v-if="showRoomID" v-html="poi.room_id || ''"></div>
		<div class="wf-poi-floor" v-if="showFloor && poi.getFloor()" v-html="poi.getFloor().getName(language) || ''"></div>
	</div>
</template>

<script>
/* global wayfinder: false */
import { mapState } from 'vuex';

export default {
	name: "POI",
	computed: {
		...mapState('wf', ['language']),
		hasShowPathListener(){
			return !!(this.$listeners && this.$listeners.showPath);
		},
		getImage () {
			// Try background first
			if (this.poi.getBackgroundUrl && this.poi.getBackgroundUrl() && this.poi.getBackgroundUrl() != null) {
				return 'url("' + this.poi.getBackgroundUrl() + '")';
			}
			// Then try logo
			else if (this.poi.getLogoUrl && this.poi.getLogoUrl() && this.poi.getLogoUrl() != null) {
				return 'url("' + this.poi.getLogoUrl() + '")';
			}
			// Then try icon
			else if (this.poi.getIconUrl && this.poi.getIconUrl() && this.poi.getIconUrl() != null) {
				return 'url("' + this.poi.getIconUrl() + '")';
			}
			else {
				// Empty transparent image
				return "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=')";
			}
		},
	},
	props: {
		poi: {
			type: Object,
			default: null
		},
		showLogo: {
			type: Boolean,
			default: false
		},
		showName: {
			type: Boolean,
			default: true
		},
		showPathButton: {
			type: Boolean,
			default: false
		},
		showDescription: {
			type: Boolean,
			default: false
		},
		showRoomID: {
			type: Boolean,
			default: false
		},
		showFloor: {
			type: Boolean,
			default: false
		}
	},
	mounted () {
		if (this.$wayfinder) {
			this.show_path = this.$wayfinder.translator.get('show_path');
			this.show_accessibility_path = this.$wayfinder.translator.get('show_accessibility_path');
		}
		
		// FORCE SCROLL FIX
		this.fixDescriptionScroll();
	},
	updated() {
		// Also fix when POI changes
		this.fixDescriptionScroll();
	},
	watch: {
		poi () {
			console.log('watch.poi')
			this.fixDescriptionScroll();
		},
		language () {
			if (this.$wayfinder) {
				this.show_path = this.$wayfinder.translator.get('show_path');
				this.show_accessibility_path = this.$wayfinder.translator.get('show_accessibility_path');
			}
		},
	},
	methods: {
		fixDescriptionScroll() {
	this.$nextTick(() => {
		const desc = this.$el.querySelector('.wf-poi-description');
		if (desc) {
			// Force the element to be scrollable
			desc.style.setProperty('overflow-y', 'scroll', 'important');
			desc.style.setProperty('overflow-x', 'hidden', 'important');
			desc.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
			desc.style.setProperty('touch-action', 'pan-y', 'important');
			desc.style.setProperty('max-height', '350px', 'important');
			desc.style.setProperty('min-height', '200px', 'important');
			// DO NOT SET HEIGHT TO AUTO - it collapses the container!
			
			// Check if content is actually scrollable
			console.log('Description scroll fix for:', this.poi.getName(this.language), {
				scrollHeight: desc.scrollHeight,
				clientHeight: desc.clientHeight,
				canScroll: desc.scrollHeight > desc.clientHeight
			});
			
			if (desc.scrollHeight > desc.clientHeight) {
				console.log('✅ Description SHOULD be scrollable');
			} else {
				console.log('⚠️ Content not tall enough to scroll - only', desc.scrollHeight, 'px');
			}
		}
	});
},
		getDescription() {
			if (!this.poi) return null;
			const desc = this.poi.getDescription ? this.poi.getDescription(this.language) : null;
			// Return null if description is false, empty, or just whitespace
			if (!desc || desc === false || desc === 'false' || (typeof desc === 'string' && desc.trim() === '')) {
				return null;
			}
			return desc;
		},
		update (id) {
			/* global wayfinder window */
			if (wayfinder.pois[id]) {
				this.poi = Object.freeze(wayfinder.pois[id]);
				this.language = wayfinder.getLanguage()
				this.$emit('titleChanged', this.poi.getName(wayfinder.getLanguage()))
				this.description = this.poi.getDescription(wayfinder.getLanguage()) ? this.poi.getDescription(wayfinder.getLanguage()) : '';
				if (this.poi.shop_logo) {
					var scope = this;
					window.requestAnimationFrame(function () {
						scope.$app.getImage(scope.poi.shop_logo).then(function (image) {
							scope.logo = image.url
						})
					});
				}
			}
		},
		showPath () {
			if (this.poi) {
				if (this.hasShowPathListener) {
					this.$emit('showPath', this.poi);
				}
				else {
					this.$wayfinder.showPath(this.poi.getNode(), this.poi);
				}
			}
		},
		open (type) {
			if (type && this.poi[type]) {
				if (type === 'shop_email') {
					window.open('mailto:' + this.poi[type], '_system')
				}
				else if (type === 'shop_phone') {
					window.open('tel:' + this.poi[type], '_system')
				}
				else {
					window.open(this.poi[type], '_system')
				}
			}
		},
		
		isImage () {
			if(this.poi.getBackgroundUrl && this.poi.getBackgroundUrl()) return "image-background";
			else if (this.poi.getLogoUrl && this.poi.getLogoUrl()) return "image-logo";
			else if (this.poi.getIconUrl && this.poi.getIconUrl()) return "image-icon";
			else return "image-none";
		},
		truncate (str, len) {
			if (str && str.length > len) {
				return str.substring(0, len) + '...';
			}
			else {
				return str;
			}
		}
	},
	data: function () {
		return {
			show_path: 'Show Path'
		}
	}
};
</script>

<style scoped>
	/* ========================================
	   BASE STYLES (Mobile First)
	   ======================================== */
	.layout-view {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}
	
	.poi-info {
		padding: 1rem;
	}

	.poi-info h2 {
		text-align: center;
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
	}

	.poi-body {
		box-shadow: 0px -2px 1px 0 rgba(0, 0, 0, 0.05);
		padding: 1rem;
		flex-grow: 1;
	}

	.poi-image {
		height: 14rem;
		width: 100%;
		background-position: 50% 50%;
		background-size: contain;
		background-repeat: no-repeat;
	}

	/* POI Image */
	.wf-poi-image {
		height: 12rem;
		width: 100%;
		background-position: center center;
		background-size: contain;
		background-repeat: no-repeat;
		margin-bottom: 1rem;
	}

	.wf-poi-image.image-background {
		background-size: cover;
	}

	.wf-poi-image.image-logo {
		background-size: contain;
	}

	.wf-poi-image.image-icon {
		background-size: contain;
	}

	.wf-poi-image.image-none {
		display: none;
	}

	.poi-image.image-background {
		background-size: cover;
	}
	
	.show-path {
		bottom: 1rem;
		right: 1rem;
		text-transform: uppercase;
		z-index: 10;
		line-height: 2.8rem;
		margin-bottom: 1.5rem;		
	}

	/* Button styling */
	.wf-show-path {
		margin-top: 1rem;
	}

	.wf-show-path .show-path-button {
		background-color: #D32F2F;
		color: white;
		height: 3rem;
		font-size: 0.95rem;
		font-weight: 700;
		line-height: 2.8rem;
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		margin: auto;
		border: 0;
		border-radius: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.5rem;
		text-transform: uppercase;
		cursor: pointer;
		width: 100%;
		transition: background-color 0.2s;
	}

	.wf-show-path .show-path-button:hover {
		background-color: #B71C1C;
	}

	.wf-show-path .show-path-button label {
		margin: 0;
		cursor: pointer;
		font-weight: 700;
	}

	.wf-show-path .path-icon {
		display: inline-block;
		vertical-align: middle;
		margin-left: 0.25rem;
	}
	
	/* Description wrapper - FIXED FOR TOUCH SCROLLING */
	.wf-poi-description-wrapper {
		position: relative;
		max-height: 400px;
		overflow: visible !important;
		display: block;
		width: 100%;
	}

	/* Description styling with AGGRESSIVE touch scrolling fixes */
	.wf-poi-description {
		line-height: 1.4;
		color: #333333;
		font-size: 0.9rem;
		padding: 0 0.5rem;
		max-height: 400px;
		min-height: 200px;
		overflow-y: scroll !important;
		overflow-x: hidden !important;
		
		-webkit-overflow-scrolling: touch !important;
		touch-action: pan-y !important;
		overscroll-behavior-y: contain !important;
		
		transform: translateZ(0);
		will-change: transform;
		position: relative;
		isolation: isolate;
		
		scrollbar-width: none !important;
		-ms-overflow-style: none !important;
	}

	/* Hide scrollbar for Chrome, Safari and Opera */
	.wf-poi-description::-webkit-scrollbar {
		display: none !important;
		width: 0 !important;
		height: 0 !important;
	}

	.poi-description {
		line-height: 1.2;
	}

	.poi-contact .address {
		font-weight: 600;
		margin-bottom: 0.5rem;
	}

	.poi-contact .address span {
		padding-top: 4px;
		vertical-align: top;
		display: inline-block;
	}

	.poi-contact .address a {
		text-decoration: none;
		display: block;
		line-height: 1.5;
	}

	.poi-contact .address .icon:before {
		mix-blend-mode: initial;
		color: white;
	}

	/* ========================================
	   MOBILE VIEW (max-width: 767px)
	   ======================================== */
	@media (max-width: 767px) {
		.wf-poi-image {
			margin-top: 1rem;
			height: 14rem;
			margin-bottom: 0.75rem;
			padding: 1rem;
			
		}

		.wf-poi-name {
			font-size: 1.75rem;
			margin-bottom: 0.5rem;
			margin-left: 2rem;
			font-weight: bold;
		}

		.wf-show-path {
			margin-top: 1rem;
			margin-left: 2rem;
			margin-right: 2rem;
		}

		.wf-show-path .show-path-button {
			height: 3.75rem;
			font-size: 2rem;
		}

		.wf-show-path .path-icon {
			width: 18px;
			height: 18px;
		}

		.wf-poi-description {
			margin-top: 1rem;
			font-size: 2rem;
			padding: 0 3rem;
			max-height: 350px;
			min-height: 250px;
			
			-webkit-overflow-scrolling: touch !important;
			touch-action: pan-y !important;
			overflow-y: scroll !important;
			overflow-x: hidden !important;
			overscroll-behavior: contain !important;
			
			pointer-events: auto !important;
			z-index: 10 !important;
		}
		
		.wf-poi-description-wrapper {
			pointer-events: none !important;
		}
		
		.wf-poi-description * {
			pointer-events: auto !important;
		}
	}

	/* ========================================
	   PORTRAIT/KIOSK VIEW (768px - 1280px)
	   ======================================== */
	@media (min-width: 768px) and (max-width: 1280px) {
		.wf-poi-image {
			margin-top: 2rem;
			padding: 4rem;
			height: 14rem;
			margin-bottom: 1rem;
		}

		.wf-poi-name {
			font-size: 2rem;
			margin-bottom: 0.75rem;
			font-weight: 600;
			margin-left: 5rem;
		}

		.wf-show-path {
			margin-top: 1.25rem;
			width: 900px;
			margin-left: 5rem;
			margin-right: 5rem;
		
		}

		.wf-show-path .show-path-button {
			height: 3.5rem;
			font-size: 2rem;
			padding-left: 2rem;
			padding-right: 2rem;
		}

		.wf-show-path .path-icon {
			width: 32px;
			height: 32px;
		}

		.wf-poi-description {
			margin-top: 1rem;
			font-size: 2rem;
			line-height: 1.5;
			padding: 0 5rem;
			max-height: 450px;
			-webkit-overflow-scrolling: touch;
		}
	}

	/* ========================================
	   LANDSCAPE/DESKTOP VIEW (min-width: 1281px)
	   ======================================== */
	@media (min-width: 1281px) {
		.wf-poi-image {
			height: 16rem;
			margin-bottom: 1.25rem;
		}

		.wf-poi-name {
			font-size: 1rem;
			margin-bottom: 1rem;
			margin-left: 1rem;
			font-weight: 600;
		}

		.wf-show-path {
			margin-top: 1.5rem;
		}

		.wf-show-path .show-path-button {
			height: 3.5rem;
			font-size: 1.1rem;
			padding-left: 2.5rem;
			padding-right: 2.5rem;
			max-width: 450px;
		}

		.wf-show-path .path-icon {
			width: 24px;
			height: 24px;
		}

		.wf-poi-description {
			font-size: 1rem;
			line-height: 1.6;
			padding: 0 1rem;
			max-width: 600px;
			margin-left: auto;
			margin-right: auto;
			max-height: 500px;
		}
	}

</style>